export default __webpack_public_path__ + "static/media/homeCenterBackground.0db24c99.jpg";